export default __webpack_public_path__ + "static/media/icon_share_mobile.e8eaab69.svg";